var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-button",class:{
        'is-large': _vm.size === 'large',
        'is-middle': _vm.size === 'middle',
        'is-small': _vm.size === 'small',
        'is-mini': _vm.size === 'mini',
        'is-primary': _vm.type === 'primary',
        'is-ghost': _vm.type === 'ghost',
        'is-transparent-dark': _vm.type === 'transparent-dark',
        'has-adaptation': _vm.adaptation === true,
    }},[_c('span',{staticClass:"button-text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }